class CardSelection extends HTMLElement {
  inputs = [];
  selected = null;

  constructor() {
    super();

    this.inputs = this.querySelectorAll('input[name="property[_card_type]"]');
    this.select = this.querySelector('#card-special-occasion');
    this.choices = new Choices(this.select, { searchEnabled: false, itemSelectText: false, position: 'bottom' });
    this.occasions = this.querySelectorAll('[data-occasion]');
  }

  connectedCallback() {
    this.inputs.forEach((input) => {
      input.addEventListener('change', this.changeSelection.bind(this));
    });

    this.select.addEventListener('change', this.changeOccasion.bind(this));

    this.selectedOccasion = this.select.value;
    this.changeOccasion();
  }

  changeOccasion(event = null) {
    this.selectedOccasion = event ? event.target.value : this.select.value;

    this.occasions.forEach((occasion) => {
      occasion.classList.toggle('hidden', occasion.dataset.occasion != this.selectedOccasion);
    });
  }

  changeSelection(event) {
    this.selected = event.target.value;

    this.inputs.forEach((input) => {
      const parentItem = input.closest('card-selection-item');
      const isSelected = input == event.target;

      if (parentItem.hasAttribute('selected') && !isSelected) {
        parentItem.removeAttribute('selected');
      } else if (isSelected) {
        parentItem.setAttribute('selected', 'selected');
      }
    });
  }

}

class CardSelectionItem extends HTMLElement {
  constructor() {
    super();

    this.selected = false;
    this.selectedStep = null;
    this.steps = false;
  }

  connectedCallback() {
    this.fieldset = this.querySelector('fieldset');
    this.steps = this.querySelectorAll('[data-step]');
    this.cardInputs = this.querySelectorAll('input[name="property[_card_id]"]');
    this.cards = this.querySelectorAll('[data-list-card]');

    if (this.cardInputs.length > 0) {
      this.cardInputs.forEach((input) => {
        input.addEventListener('change', () => this.selectCard(input));
      });
    }

    this.querySelectorAll('[data-list-reset]').forEach((item) => {
      item.addEventListener('click', () => this.resetStep());
    });

    if (this.steps.length > 0 && this.selectedStep === null) {
      this.updateStep(1);

      this.querySelectorAll('[data-step-reset]').forEach((item) => {
        item.addEventListener('click', () => this.resetStep());
      });
    }

    // Listen for changes to the 'selected' attribute on this element
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'selected') {
          this.selected = this.hasAttribute('selected');
          this.updateState();
        }
      }
    });

    observer.observe(this, { attributes: true, attributeFilter: ['selected'] });

    this.updateState();
  }

  updateStep(stepNumber) {
    if (this.selectedStep === stepNumber) return false;

    this.selectedStep = stepNumber;

    this.steps.forEach((step) => {
      step.classList.toggle('hidden', step.dataset.step != stepNumber);
    });

    this.cards.forEach((card) => {
      card.classList.toggle('hidden', card.dataset.listCard != this.selected);
    });
  }

  selectCard(input) {
    this.selected = input.value;
    this.updateStep(2);
  }

  resetStep() {
    this.selected = null;

    if (this.cardInputs.length > 0) {
      this.cardInputs.forEach((input) => {
        input.checked = false;
      });
    }

    this.updateStep(1);
  }

  updateState() {
    if (this.fieldset) {
      this.fieldset.toggleAttribute('disabled', !this.selected);
    }
  }
}

// Prevents issues with the custom elements having incorrect references
document.addEventListener('product-info:loaded', () => {
  customElements.define('card-selection', CardSelection);
  customElements.define('card-selection-item', CardSelectionItem);
});
